module.exports = __webpack_public_path__ + "img/icon-dictionary.c66370d0.svg";